import React from 'react';

import { styled, Theme } from '@material-ui/core/styles';
import Paper, { PaperProps } from '@material-ui/core/Paper';

type StyledOutlinedPaperProps = PaperProps & {
  theme: Theme;
};

export const StyledOutlinedPaper = styled(
  ({ theme, ...props }: StyledOutlinedPaperProps) => (
    <Paper variant="outlined" {...props} />
  )
)(({ theme }: StyledOutlinedPaperProps) => ({
  borderRadius: theme.shape.radius.large,
}));
